import produce from 'immer';
import * as _ from 'lodash';

import { errorMessagesListFromResponse } from '../../helpers/errors';
import { createReducer, getErrorStatus, getInitialStatus, getPendingStatus } from '../utils';
import type { UpdateTeamProjectsResponse } from '../../../typings/api';

import { ADD_TEAM_PROJECTS, FETCH_ALL_TEAMS, SET_TEAM_SELECTION, SET_TEAM_USER_ROLE } from './actions';
import type { TeamsStore } from '.';

const initialState: TeamsStore = {
  teams: {},
  status: getInitialStatus(),
  teamUpdatingStatus: {
    loading: false,
    errors: [],
  },
  teamSelection: [],
};

export default createReducer(initialState, {
  // fetch all actions
  [`${FETCH_ALL_TEAMS}_PENDING`]: (state) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${FETCH_ALL_TEAMS}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.status = getInitialStatus();
    (action.payload.data || []).forEach((team) => {
      if (team?.id) {
        draftState.teams[team.id] = team;
      }
    });
  }),
  [`${FETCH_ALL_TEAMS}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),
  [`${ADD_TEAM_PROJECTS}_PENDING`]: (state) =>
    produce(state, draftState => {
      draftState.teamUpdatingStatus.loading = true;
      draftState.teamUpdatingStatus.errors = [];
    }),
  [`${ADD_TEAM_PROJECTS}_FULFILLED`]: (state, action) =>
    produce(state, draftState => {
      const { id, projects }: UpdateTeamProjectsResponse = action.payload.data;
      const team = draftState.teams[id];
      if (team) {
        team.teamProjects = projects.map(projectId => ({ projectId }));
      }
      draftState.teamUpdatingStatus.loading = false;
    }),
  [`${ADD_TEAM_PROJECTS}_REJECTED`]: (state, action) =>
    produce(state, draftState => {
      draftState.teamUpdatingStatus.loading = false;
      draftState.teamUpdatingStatus.errors = errorMessagesListFromResponse(action.payload);
    }),

  [SET_TEAM_USER_ROLE]: (state, action) =>
    produce(state, draftState => {
      const { teamId, ...userRole } = action.payload;
      if (draftState.teams[teamId]) {
        draftState.teams[teamId].teamUsers = _.unionBy(
          [userRole],
          draftState.teams[teamId].teamUsers || [],
          teamUser => teamUser.userId,
        );
      }
    }),

  [SET_TEAM_SELECTION]: (state, action) =>
    produce(state, draftState => {
      draftState.teamSelection = action.payload;
    }),
});
